import React, {useState,useEffect } from "react";
import { DataGridBox } from "./ServiceDistributionStyled";
import MuiPagination from '@mui/material/Pagination';
import {
  DataGrid,
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

function GridCutomPagination({
  page,
  onPageChange,
  className,
}) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
  
}
export const ServiceDistribution = ({
  utilizationDistributionRows,
  headers,
  handleUpdate,
  handleRowMode
}) => {
  const [rowData, setRowData] = useState([...utilizationDistributionRows]);
  if(headers.length<=10)
    {
      headers.map((x)=>x.width=210);
    }
    useEffect(() => {
      setRowData(utilizationDistributionRows);
    }, [utilizationDistributionRows]);
  
  function getRowId(row) {
    return row.Id;
  }

function CustomPagination(props) {
  return <GridPagination ActionsComponent={GridCutomPagination} {...props} />;
}
  return (
    <>
      <DataGridBox sx={{ height: 400, width: '100%' }}>
        <DataGrid  
          slots={{pagination: CustomPagination}}
          rows={[...rowData]}
          getRowId={getRowId}
          editMode="row"
          getRowHeight={() => 'auto'} 
          getRowClassName={(params) => {
            return "custom-row-class"; 
          }}
          pagination
          columns={headers}
          processRowUpdate={(updatedRow, originalRow) =>
            handleUpdate(updatedRow)
          }
          onRowEditStart={handleRowMode}
          // onCellKeyDown={(updatedRow, originalRow) =>
          //   handleUpdate(updatedRow)}
          disableColumnSelector
          disableColumnMenu={true}
        />
      </DataGridBox>
    </>
  );
};

export default ServiceDistribution;
